/// <reference path="../../_ext/Bases/GridBase.ts" />

namespace TabAurous.OMS {
    import fld = FixedRateMasterRow.Fields;
    @Serenity.Decorators.registerClass()
    export class FixedRateMasterGrid extends _Ext.GridBase<FixedRateMasterRow, any> {
        protected getColumnsKey() { return 'OMS.FixedRateMaster'; }
        protected getDialogType() { return FixedRateMasterDialog; }
        //protected getIdProperty() { return 'ProductId'; }
      protected getIdProperty() { return "__id"; }
        protected getInsertPermission() { return FixedRateMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return FixedRateMasterRow.localTextPrefix; }
        protected getService() { return FixedRateMasterService.baseUrl; }
        private pendingChanges: Q.Dictionary<any> = {};
        private nextId = 1;

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected getColumns() {

            var columns = super.getColumns();


            Q.first(columns, x => x.field === fld.PurchaseRate).format = ctx => this.numericInputFormatter(ctx);
            Q.first(columns, x => x.field === fld.SalesRate).format = ctx => this.numericInputFormatter(ctx);


            this.view.refresh();
            return columns;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            buttons.push({
                title: "Update Rates",
                cssClass: "add-button",
                hotkey: "Alt + K",
                onClick: e => this.saveClick(),

            });
            return buttons;
        }

        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');

            var pending = this.pendingChanges[item.CostId];

            var effective = this.getEffectiveValue(item, field);
            var oldText: string;
            if (input.hasClass("numeric"))
                oldText = Q.formatNumber(effective, '0.##');
            else
                oldText = effective as string;

            var value;
            if (field === fld.PurchaseRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            } else if (field === fld.SalesRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass("numeric")) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else
                value = text;

            if (!pending) {
                this.pendingChanges[item.CostId] = pending = {};
            }
            pending["ProductId"] = item.ProductId;
            pending["CostId"] = item.CostId;
            pending["AttributeId"] = item.AttributeId;
            pending["ItemTypeId"] = item.ItemTypeId;
            pending[field] = value;
            item[field] = value;
            this.view.updateItem(item["__id"], item);
            this.view.refresh();

            if (input.hasClass("numeric"))
                value = Q.formatNumber(value, '0.##');

            input.val(value).addClass('dirty');
            this.setSaveButtonState();
        }
        private setSaveButtonState() {
            this.toolbar.findButton('apply-changes-button').toggleClass('disabled',
                Object.keys(this.pendingChanges).length === 0);
        }

        private saveClick() {
            if (Object.keys(this.pendingChanges).length === 0) {
                return;
            }

            // this calls save service for all modified rows, one by one
            // you could write a batch update service
            var keys = Object.keys(this.pendingChanges);
            var current = -1;
            var self = this;

            (function saveNext() {
                if (++current >= keys.length) {
                    self.refresh();
                    return;
                }

                var key = keys[current];
                var entity = Q.deepClone(self.pendingChanges[key]);
                entity.Id = key;
                var newrate: FixedRateMasterRow = {
                    AttributeId: /*entity.ItemTypeId==101?*/entity.AttributeId/*:0*/,
                    ProductId: entity.ProductId,
                    PurchaseRate: entity.PurchaseRate,
                    SalesRate: entity.SalesRate,
                    ToWt: 0,
                    FromWt: 0
                }
                if (entity.CostId == 0) {
                    entity.CostId = null;
                    FixedRateMasterService.Create({ Entity: newrate }, response => {
                        delete self.pendingChanges[key];
                        saveNext();
                    }, { async: false }
                    )
                } else {
                    FixedRateMasterService.Update({ Entity: newrate, EntityId: entity.CostId },
                        response => {
                            delete self.pendingChanges[key];
                            saveNext();
                        }, { async: false }
                    )
                }
            })();
        }


        private numericInputFormatter(ctx) {
            var klass = 'edit numeric';
            var item = ctx.item as FixedRateMasterRow;
            var pending = this.pendingChanges[item.CostId];

            if (pending && pending[ctx.column.field] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValue(item, ctx.column.field) as number;
            var width = (ctx.column.width) as number - 10;


            return "<input type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
                "' data-field='" + ctx.column.field +
                "' value='" + Q.formatNumber(value, '0.##') + "'/>";
        }


        private getEffectiveValue(item, field): any {
            var pending = this.pendingChanges[item.Id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }

            return item[field];
        }
        protected onViewProcessData(response: Serenity.ListResponse<FixedRateMasterRow>) {
            response = super.onViewProcessData(response);

            // there is no __id property in SalesByCategoryRow but 
            // this is javascript and we can set any property of an object
            for (var x of response.Entities) {
                (x as any).__id = this.nextId++;
            }
            return response;
        }
    }
}